import React from 'react'
import SiteUpdating from './Components/SiteUpdating'
import './Styles/App.css';

const App = () => {
  return (  
      <SiteUpdating/>
  )
}

export default App